// import * as React from 'react';
import {connect} from "react-redux";
import ServiceList from "../components/ServiceList";
import {isOnline} from "../actions/userActions";
import {loadServices} from "../actions/serviceActions";
import {isProcessing} from "../actions/processingActions";
import {PROC_SERVICE_LIST} from "../actions";
import {push} from "react-router-redux";


const m2s = state => ({
	services: Object.values(state.service.list),
	isLoading: isProcessing(state, PROC_SERVICE_LIST)
});
const m2d = dispatch => {
	dispatch(isOnline(() => {
		dispatch(loadServices());
	}));
	return {
		push: to => dispatch(push(to))
	};
};

export default connect(m2s, m2d)(ServiceList);


// WEBPACK FOOTER //
// ./src/containers/ServiceListController.js